import Api from '../functions/api';
import { serialize } from '../functions/objectToQuery';

const aprovarSolicitacao = (listaDeIds) => {
  return Api.put('/SolicitacaoEmailInstituicaoDeEnsino/Aprovar', listaDeIds);
};

const criar = (dados) => {
  return Api.post('/SolicitacaoEmailInstituicaoDeEnsino', dados);
};

const editar = (body, id) => {
  return Api.put(`/SolicitacaoEmailInstituicaoDeEnsino/${id}`, body);
};

const obterInstituicoesPorUsuario = () => {
  return Api.get('/SolicitacaoEmailInstituicaoDeEnsino/PreenchimentosPendentes');
};

const obterPorId = (id) => {
  return Api.get(`/SolicitacaoEmailInstituicaoDeEnsino/${id}`);
};

const obterPorListaDeId = (listaDeIds) => {
  const params = listaDeIds.join('&solicitacoesIds=');
  return Api.get(`SolicitacaoEmailInstituicaoDeEnsino/solicitacoesIds?solicitacoesIds=${params}`);
};

const obterTodasSolicitacoes = (filter) => {
  return Api.get(`/SolicitacaoEmailInstituicaoDeEnsino?${serialize(filter)}`);
};

const recusarEmail = (dados) => {
  return Api.put('/SolicitacaoEmailInstituicaoDeEnsino/Rejeitar', dados);
};

const verificaPossuiPendencia = () => {
  return Api.get('/SolicitacaoEmailInstituicaoDeEnsino/PossuiPendencia');
};

export const EmailStore = {
  aprovarSolicitacao,
  criar,
  editar,
  obterInstituicoesPorUsuario,
  obterPorId,
  obterTodasSolicitacoes,
  obterPorListaDeId,
  recusarEmail,
  verificaPossuiPendencia,
};
